import React from 'react';

import Icon from 'components/DesignSystem/Icon';
import { cssVar } from 'constants/theme';

import './index.scss';

export default function FullscreenHeatmap({
  open,
  dismiss,
  base64,
}: {
  open: boolean;
  dismiss: () => void;
  base64: string;
}) {
  if (!open) return null;

  return (
    <div className="observed-data-fullscreen-overlay">
      <button
        type="button"
        aria-label="Sair do modo tela cheia"
        className="observed-data-fullscreen-close"
        onClick={dismiss}
      >
        <Icon iconType="close" color={cssVar('text-strong')} />
      </button>
      <div className="observed-data-fullscreen-rotate">
        <img
          className="observed-data-fullscreen-image"
          src={`data:image/png;base64,${base64}`}
          alt="Heatmap"
        />
      </div>
      <span className="observed-data-fullscreen-caption">
        Modo paisagem · toque no X para sair
      </span>
    </div>
  );
}
